import { Link } from "react-router-dom";
import "./sidebar.css";

const Sidebar = () => {
  return (
    <aside className="sidebar">
      <ul className="sidebar-links">
        <li>
          <Link to="/student">Create Your Profile</Link>
        </li>
        <li>
          <Link to="/Studentdetail">Your Details</Link>
        </li>

        <li>
          <Link to="/Discount">Commission ( % )</Link>
        </li>

        <li>
          <Link to="/Studentcommission">Student Commission Details</Link>
        </li>
        {/* <li>
          <Link to="/email-coupon-transactions">Referral Transactions</Link>
        </li> */}

        <li>
          <Link to="/Term">Term and Conditions</Link>
        </li>
      </ul>
    </aside>
  );
};
export default Sidebar;
